jQuery(function($)
{
    var
        { map } = orion,
        ZIPCODE = 'zipcode',
        COUNTRYCODE = 'countryCode',
        META_SUFFIX_ZIPCODE_FEEDBACK_INVALID = '_' + ZIPCODE + '_feedback_invalid',
        META_SUFFIX_ZIPCODE_FEEDBACK_MISSING = '_' + ZIPCODE + '_feedback_missing',
        META_SUFFIX_ZIPCODE_MAX = '_' + ZIPCODE + '_maxlength',
        META_SUFFIX_ZIPCODE_MIN = '_' + ZIPCODE + '_minlength',
        META_SUFFIX_ZIPCODE_PATTERN = '_' + ZIPCODE + '_pattern',
        ATTRIBUTE_SUFFIX_ZIPCODE = '[' + ZIPCODE + ']',
        ATTRIBUTE_SUFFIX_COUNTRYCODE = '[' + COUNTRYCODE + ']',
        ATTR_MAXLENGTH = 'maxlength',
        ATTR_MINLENGTH = 'minlength',
        ATTR_PATTERN = 'pattern',
        TEXT_FEEDBACK_INVALID = '.feedback.invalid',
        TEXT_FEEDBACK_MISSING = '.feedback.missing',
        $zipCode = $('[name$="' + ATTRIBUTE_SUFFIX_ZIPCODE + '"]'),
        $countryCode = $('[name$="' + ATTRIBUTE_SUFFIX_COUNTRYCODE + '"]'),
        metaName = {
            '.feedback.invalid': META_SUFFIX_ZIPCODE_FEEDBACK_INVALID,
            '.feedback.missing': META_SUFFIX_ZIPCODE_FEEDBACK_MISSING,
            'maxlength': META_SUFFIX_ZIPCODE_MAX,
            'minlength': META_SUFFIX_ZIPCODE_MIN,
            'pattern': META_SUFFIX_ZIPCODE_PATTERN
        },
        metaElements = map(metaName, function(name)
        {
            return $('meta[name$="' + name + '"]');
        }),
        metaData = (function()
        {
            var i,
                metaData = {};

            for (i in metaElements)
            {
                if (Object.prototype.hasOwnProperty.call(metaElements, i))
                {
                    metaElements[i].each(function()
                    {
                        var
                            $meta = $(this),
                            countryCode = $meta.attr('name').slice(0, -metaName[i].length),
                            thisMetaData = {};

                        thisMetaData[countryCode] = {
                            'attr': {},
                            'text': {}
                        };
                        switch (i)
                        {
                        case ATTR_MAXLENGTH:
                        case ATTR_MINLENGTH:
                        case ATTR_PATTERN:
                            thisMetaData[countryCode]['attr'][i] = $meta.attr('content');
                            break;
                        case TEXT_FEEDBACK_INVALID:
                        case TEXT_FEEDBACK_MISSING:
                            thisMetaData[countryCode]['text'][i] = $meta.attr('content');
                            break;
                        default:
                            break;
                        }

                        $.extend(true, metaData, thisMetaData);
                    });
                }
            }
            return metaData;
        })();

    /*
	 *function getTextNodesIn(node, includeWhitespaceNodes) {
	 * var textNodes = [],
	 * nonWhitespaceMatcher = /\S/;
	 *
	 * function getTextNodes(node) {
	 * if (node.nodeType == 3) {
	 * if (includeWhitespaceNodes || nonWhitespaceMatcher.test(node.nodeValue)) {
	 * textNodes.push(node);
	 * }
	 * } else {
	 * for (var i = 0, len = node.childNodes.length; i < len; ++i) {
	 * getTextNodes(node.childNodes[i]);
	 * }
	 * }
	 * }
	 *
	 * getTextNodes(node);
	 * return textNodes;
	 *}
	 */

    function updateAttributes($el, metaData)
    {
        $el.attr(metaData);
    }

    function updateText($el, metaData)
    {
        var selector, icon;

        for (selector in metaData)
        {
            if (Object.prototype.hasOwnProperty.call(metaData, selector))
            {
                icon = $el.siblings('.feedback_box').find(selector)
                    .find('.icon');
                $el.siblings('.feedback_box').find(selector)
                    .empty()
                    .append(icon);
                $el.siblings('.feedback_box').find(selector)
                    .append(metaData[selector]);
            }
        }
    }

    function delegateUpdates(o)
    {
        var
            $countryCode = $(this),
            countryCode = $countryCode.val(),
            $zipCode = $countryCode.data('$zipCode');

        if (!metaData[countryCode])
        {
            return;
        }

        o = $.extend({}, { 'triggerValidationParametersChanged': false }, o);

        updateAttributes($zipCode, metaData[countryCode].attr);
        updateText($zipCode, metaData[countryCode].text);

        if (o.triggerValidationParametersChanged && $zipCode.val().length !== 0)
        {
            $zipCode.trigger(orion.constants.EventValidationParametersChanged);
        }
    }

    function handleChange()
    {
        delegateUpdates.apply(this, [{ 'triggerValidationParametersChanged': true }]);
    }

    function initialize()
    {
        $zipCode.each(function()
        {
            var
                $zipCode = $(this),
                groupName = $zipCode.attr('name').slice(0, -ATTRIBUTE_SUFFIX_ZIPCODE.length),
                $countryCode = $('[name="' + groupName + '[' + COUNTRYCODE + ']"]');

            $zipCode.data('$countryCode', $countryCode);
            $countryCode.data('$zipCode', $zipCode);
        });

        $countryCode.each(delegateUpdates);
    }

    initialize();
    $countryCode.filter('select').on('change', handleChange);
});
